// extracted by mini-css-extract-plugin
module.exports = {"main":"InfoSection_main__wDubG"};